import React, { useContext, useEffect, useState } from 'react';
import styles from './styles.module.css';
import * as NumberFormatHelper from '../../../helpers/NumberFormatHelper';
import { QR_PREFIX, STORAGE_KEY } from '../../../const';
import { useParams } from 'react-router-dom';
import { ShopContext } from '../../../contexts/ShopContext';
import QRCode from 'qrcode.react';
import { Grid } from '@mui/material';
import PageHeader from '../../utils/PageHeader/PageHeader';
import ProductView from '../../utils/ProductView/ProductView';
import DateTimeHelpers from '../../../helpers/DateTimeHelpers';
import SuccessIcon from '../../icons/success_icon.png';

function OrderDetails() {
  const { shop } = useContext(ShopContext);
  const [orderData, setOrderData] = useState(null);
  const { orderId } = useParams();

  useEffect(() => {
    const orders = JSON.parse(localStorage.getItem(`${shop.shopId}-${STORAGE_KEY.ORDERS}`) || '[]');
    const order = orders.find((ord) => ord?.id === Number(orderId)) || {};
    setOrderData(order);
  }, [orderId, shop.shopId]);

  return (
    <div className={styles.container}>
      <div className={styles.statusContainer}>
        <div className={styles.statusContent}>
          <PageHeader
            title={'Order Placed'}
            backToHome={true}
            color="#fff"
            showBorder={false}
          />
          <div className={styles.statusWrapper}>
            <img src={SuccessIcon} alt="" />
            <span className={styles.head}>Order Placed</span>
            <span className={styles.text}>Thank you for ordering</span>
            <span className={styles.text}>We are processing your order</span>
          </div>
        </div>
      </div>
      <Grid container className={styles.orderContainer}>
        <Grid item container xs={12}>
          <Grid item xs={12} display="flex" justifyContent="space-between" alignItems="center" pt={1.5}>
            <span className={styles.text2}>Order ID</span>
            <span className={styles.hilightText}>{orderData?.id}</span>
          </Grid>
          <Grid item xs={12} display="flex" justifyContent="space-between" alignItems="center" pt={1.5}>
            <span className={styles.text2}>Date</span>
            <span className={styles.hilightText}>
              {orderData?.created_at && DateTimeHelpers.getDate(new Date(orderData.created_at))}
            </span>
          </Grid>
          <Grid item xs={12} display="flex" justifyContent="space-between" alignItems="center" pt={1.5}>
            <span className={styles.text2}>Time</span>
            <span className={styles.hilightText}>
              {orderData?.created_at && DateTimeHelpers.getTime12HFormat(orderData.created_at)}
            </span>
          </Grid>
        </Grid>
        <Grid item xs={12} pt={2}>
          <div className={styles.divider}></div>
        </Grid>
        <Grid item container rowSpacing={1} xs={12} pt={2} display="flex" alignContent="flex-start">
          {(orderData?.details?.items || []).map((item, index) => (
            <ProductView key={item.id || index} product={item} orderView={true} showActionSection={false} />
          ))}
        </Grid>
        <Grid item xs={12} pt={2}>
          <div className={styles.divider}></div>
        </Grid>
        <Grid item xs={12} pt={2}>
          <span className={styles.header}>Payment Summary</span>
        </Grid>
        <Grid item xs={12} display="flex" justifyContent="space-between" alignItems="center" pt={2}>
          <span className={styles.text2}>Price</span>
          <span className={styles.text3}>
            {NumberFormatHelper.amountFormat(orderData?.details?.subTotal || orderData?.details?.amount || 0, shop)}
          </span>
        </Grid>
        <Grid item xs={12} display="flex" justifyContent="space-between" alignItems="center" pt={1}>
          <span className={styles.text2}>Tax</span>
          <span className={styles.text3}>
            {NumberFormatHelper.amountFormat(orderData?.details?.tax || 0, shop)}
          </span>
        </Grid>
        <Grid item xs={12} display="flex" justifyContent="space-between" alignItems="center" pb={1}>
          <span className={styles.text2}>Discount</span>
          <span className={styles.text3}>
            {NumberFormatHelper.amountFormat(orderData?.details?.discount || 0, shop)}
          </span>
        </Grid>
        <Grid
          item
          xs={12}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          pt={1}
          className={styles.divTopBorder}
        >
          <span className={styles.text2}>Total Payment</span>
          <span className={styles.text3}>
            {NumberFormatHelper.amountFormat(orderData?.details?.payable || orderData?.details?.amount || 0, shop)}
          </span>
        </Grid>

        <Grid item xs={12} pt={2}>
          <div className={styles.divider}></div>
        </Grid>
        <Grid item xs={12} pt={2.5} display="flex" alignItems="center" justifyContent="center" textAlign="center">
          <span className={styles.text2} style={{ lineHeight: '18px' }}>
            Scan your QR code at the counter and <br />
            grab your order hassle-free!
          </span>
        </Grid>
        <Grid item xs={12} pt={2.5} display="flex" alignItems="center" justifyContent="center" pb={5}>
          <QRCode
            value={QR_PREFIX + JSON.stringify({ id: orderData?.id, secret: orderData?.secret })}
            size={140}
            style={{ borderRadius: '12px' }}
          />
        </Grid>
        <Grid item xs={12} style={{ height: '60px' }}></Grid>
      </Grid>
    </div>
  );
}

export default OrderDetails;
